<template>
    <div :class="$common.getStyleName('pack-componesnts-content')" v-if="packagelistDone && $_.size(GET_PACKAGE_PACKS_DATA.content) > 0">
        <div :class="$common.getStyleName('payment-pack1')">
            <div :class="$common.getStyleName('payment-pack1-top')"></div>
            <div :class="$common.getStyleName('payment-pack-mid')">
                <!--tags-->
                <div :class="$common.getStyleName('payment-pack1-tab1')" v-show="$_.size(GET_PACKAGE_PACKS_DATA.tagTab) > 1">
<!--                    <h4><span>1.</span>{{$t('select_pay_channel_country')}}</h4>-->
                    <ul>
                        <li :data-key="key" @click="CLICK_USER_SELECTED_CHANNEL_PACKAGE_TAG({key:key,type : 'package'})"
                            :class="key===GET_PACKAGE_PACKS_DATA.activeTagKey ? 'active' : ''"
                            v-for="item,key in GET_PACKAGE_PACKS_DATA.tagTab"><span v-html="item"></span></li>
                    </ul>
                </div>
                <!--tags-->
                <!--operator-->
                <div :class="$common.getStyleName('payment-pack1-tab2')" v-show="$_.size(GET_PACKAGE_PACKS_DATA.operatorTab[GET_PACKAGE_PACKS_DATA.activeTagKey]) > 1">
                    <h4><span>{{$_.size(GET_PACKAGE_PACKS_DATA.tagTab)===1 ? '1.':'2.'}}</span>{{$t('select_pay_channel_operator')}}</h4>
                    <ul>
                        <li :data-key="key" @click="CLICK_USER_SELECTED_CHANNEL_PACKAGE_OPERATOR({key:key,type:'package'})"
                            :class="key===GET_PACKAGE_PACKS_DATA.operatorTabStatus[GET_PACKAGE_PACKS_DATA.activeTagKey]?'active': ''"
                            v-for="item,key in GET_PACKAGE_PACKS_DATA.operatorTab[GET_PACKAGE_PACKS_DATA.activeTagKey]"><span v-if="isSMSOperatorOther(item)" class="other" v-html="$t('select_pay_ohter')"></span>

                            <span
                            v-if="!isSMSOperatorOther(item) && !getOperatorImageUrl(item)" v-html="item"></span><img v-if="!isSMSOperatorOther(item) && getOperatorImageUrl(item)" :src="getOperatorImageUrl(item)" :alt="item" /><i></i></li>
                    </ul>
                </div>
                <!--operator-->
                <div :class="$common.getStyleName('payment-pack1-content')">
                    <ul>
                        <!--item-->
                        <li :data-productId="item.amount_id" v-for="(item,index) in GET_PACKAGE_PACKS_DATA_CONTENT"
                            @click="CLICK_USER_SELECTED_CHANNEL_PACKAGE_INFO({item:item,index:index,type:'package'})"
                            :class="getPacksActiveCssName(index,item)">
                            <div :class="$common.getStyleName('payment-pack1-item')">
                                <div :class="$common.getStyleName('payment-pack1-hot')" v-show="item['amount_is_recommend'] === 'Y'"></div>
                                <div :class="$common.getStyleName('payment-pack1-point')">
                                    <span><img v-if="item['dns_object_url']" :src="item['dns_object_url']" alt="gold"></span>
                                    <strong :class="$common['setfontSizePoint'](item['virtual_goods'])" v-html="item['virtual_goods']"></strong>
                                </div>
                                <div :class="$common.getClassName('add-icon')" v-if="item['virtual_goods_reward'] !== 0">+</div>
                                <div :class="$common.getStyleName('payment-pack1-gift')">
                                    <span v-if="item['virtual_goods_reward'] !== 0"><img v-if="item['dns_object_url_reward']" :src="item['dns_object_url_reward']" alt="gold"></span>
                                    <strong :class="$common['setfontSizeGift'](item['virtual_goods_reward'])" v-if="item['virtual_goods_reward'] !== 0" v-html="item['virtual_goods_reward']"></strong>
                                </div>
                                <div :class="`${$common.getStyleName('payment-pack1-number')} ${$common['setfontSizePrice'](item['show_price'])}`" v-html="item['show_currency'] + ' ' + item['show_price']" ></div>
                                <div :class="$common.getClassName('select-cont')" v-if="getPacksActiveCssName(index,item) === 'active'"></div>
                            </div>
                        </li>
                        <!--item end-->
                    </ul>
                </div>
            </div>
            <div :class="$common.getStyleName('payment-pack1-bottom')"></div>
        </div>
        <div :class="$common.getStyleName('payment-pack1-btn')"><a @click="onSubmit()" href="javascript:void(0)"><span>{{$t('submit')}}</span></a></div>
    </div>
</template>

<script>
    import {mapState, mapActions, mapGetters, mapMutations} from 'vuex';

    export default {
        name: 'pack1',
        data() {
            return {};
        },
        computed: {
            ...mapState(['$modulList','$common','$_','$appConfig','$lang']),
            ...mapState('Module_Package', ['packagelist', 'packagelistDone']),
            ...mapState('Module_User', ['selectedUserData']),
            ...mapState('Module_Server', ['selectedServerData']),
            ...mapGetters('Module_Package', ['GET_PACKAGE_PACKS_DATA','GET_ACTIVE_CHANNEL_DATA','GET_PACKAGE_PACKS_DATA_CONTENT']),
        },
        methods : {
            ...mapActions('Module_Package', ['CLICK_USER_SELECTED_CHANNEL_PACKAGE_INFO','CLICK_USER_SELECTED_CHANNEL_PACKAGE_TAG', 'CLICK_USER_SELECTED_CHANNEL_PACKAGE_OPERATOR']),
            ...mapActions('Module_Post_order', ['SUBMIT']),

            /**
             * 获取当前渠道下的运营商图片
             * @param code
             */
            getOperatorImageUrl(code){
                let operatorData = this.GET_ACTIVE_CHANNEL_DATA['operator_data'];
                let url = null;
                for(let key in operatorData){
                    if(operatorData[key]['code'] === code){
                        url = operatorData[key]['img']
                    }
                }
                return url;
            },

            /**
             * 获取当前渠道下的运营商图片
             * @param lang
             */
            isSMSOperatorOther(lang){
                let langs = this.$lang['select_pay_ohter'];
                let flag = false;
                if(langs === lang) {
                    flag = true;
                }
                return flag;
            },

            /**
             * 获取当前样式
             * @param item
             * @param index
             */
            getPacksActiveCssName(index,item) {
                return this.GET_PACKAGE_PACKS_DATA.channelMap[item.tag_md5_key][item.sms_tag_md5_key] === index ? 'active' : ''
            },

            /**
             * 用户下单操作
             */
            onSubmit(){
                let index = this.GET_PACKAGE_PACKS_DATA.channelMap[this.GET_PACKAGE_PACKS_DATA.activeTagKey][this.GET_PACKAGE_PACKS_DATA.operatorTabStatus[this.GET_PACKAGE_PACKS_DATA.activeTagKey]];
                let data = {
                    $appConfig: this.$appConfig,
                    $common: this.$common,
                    $lang: this.$lang,
                    selectedPackageData: this.GET_PACKAGE_PACKS_DATA_CONTENT[index],
                    selectedUserData: this.selectedUserData,
                    selectedServerData: this.selectedServerData,
                    packagetType: 'packs',
                    channel :this.GET_ACTIVE_CHANNEL_DATA

                };

                console.log('selectedData=>', this.GET_PACKAGE_PACKS_DATA);
                console.log('selectedTabValue=>', this.GET_PACKAGE_PACKS_DATA.selectedTabValue);
                console.log('data=>', data);
                console.log('virtual_goods_reward=>',data.selectedPackageData['virtual_goods_reward']);
                console.log('virtual_goods=>', data.selectedPackageData['virtual_goods']);

                this.SUBMIT(data);
            }

        }
    }
</script>

<style type="scss">

</style>



// WEBPACK FOOTER //
// website/components/package/packs/Pack1.vue